<template>
  <CCol
    :key="item.id"
    :xl="checkLength()"
    :lg="checkLength()"
    :md="checkLength()"
    :sm="checkLength()"
    class="p-1 matrix-mobile"
  >
    <div
      class="matrix"
      :id="item.comment"
      @click="getItemID(item.comment, item.data)"
    >
      <div class="checkDisplay">
        <div class="containerSmallAudio">
          <font-awesome-icon
            class="MatrixSmallAudio"
            icon="volume-up"
          ></font-awesome-icon>
        </div>
      </div>
      <h2 class="info-desc m-0 pt-4 pb-4 fontPinyin">{{ item.data }}</h2>
    </div>
  </CCol>
</template>
<script>
export default {
  components: {},
  name: "MartixChoice",
  props: {
    item: Object,
    dataLength: Number,
    count: Number,
    CheckWidth: Number,
  },
  data() {
    return {
      lang: "",
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  created() {
    this.checkLength();
    this.lang = this.$store.state.language.language;
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    getItemID(id, data) {
      this.$emit("parentOnClick", id, data);
    },
    checkLength() {
      if (this.dataLength <= 4) {
        // var a = this.funCcheckWidth()
        return "6";
        // return a;
      } else if (this.dataLength > 4 && this.dataLength <= 7) {
        return "4";
      } else if (this.dataLength > 7 && this.dataLength <= 10) {
        return "4";
      } else if (this.dataLength > 10) {
        var a = this.funCcheckWidth();

        return a;
      }
    },
    funCcheckWidth(val) {
      if (this.CheckWidth < 350) {
        return "1";
      } else if (this.CheckWidth > 351) {
        return "4";
      }
    },
  },
};
</script>

<style scoped>
.matrix {
  width: 100%;
  height: 100%;
  justify-content: center;
  text-align: center;
  border-radius: 15px;
  margin-bottom: 0rem !important;
  background-color: white;
  outline: 0 !important;
  border: 5px solid white;
}

.matrix:hover {
  background-color: lightgray;
  box-shadow: 2px 2px 8px lightgray;
  cursor: pointer;
  border: 5px solid lightgray;
}

.matrix-active {
  width: 100%;
  height: 100%;
  justify-content: center;
  text-align: center;
  border-radius: 15px;
  margin-bottom: 0rem !important;
  background-color: #84d19b;
  border: 5px solid #457ae6;
  outline: 0 !important;
}

.matrix-active:hover {
  background-color: #84d19b;
  border: 5px solid #457ae6;
  cursor: pointer;
}

.checkDisplay {
  display: none;
}

@media screen and (max-width: 416px){
  .matrix-mobile {
    width: 50%;
  }
}
</style>
